module.exports = __webpack_public_path__ + "img/shop3.a533ed6b.png";